<template lang="html">
  <div class="cubes_palette select">
    <img v-if="emptyTile" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAYAAACNbyblAAAAD0lEQVQYV2NkwAIYaSAIAAGkAAa+Ds1zAAAAAElFTkSuQmCC" class="bg_transparent" :class="{'selected': tileIndex === -1}" @click="selectTile(-1)" />
    <img v-if="tileImgs" v-for="(img, index) in tileImgs" :key="index" :src="img || 'assets/images/pacman.svg'" :class="{'bg_transparent': img, 'selected': tileIndex === index}" @click="selectTile(index)" />
    <div v-if="!tileImgs">Carregando...</div>
  </div>
</template>

<script>
import GameStudio from '@/assets/js/GameStudio.js'
const TilemapViewer = window.TilemapViewer;

export default {
  props: ['tilesetId', 'tileIndex', 'assetsCache', 'autoFlushCache', 'emptyTile'],
  data() {
    return {
      tilesets: GameStudio.getFilesWithExtensions(['.tileset']).toIdData(),
      tilemapViewer: null,
      tileImgs: null
    };
  },
  computed: {
    tileset() {
      try {
        return this.tilesets[this.tilesetId];
      } catch {
        return null;
      }
    }
  },
  methods: {
    renderTiles() {
      if (this.autoFlushCache) {
        this.tilemapViewer.tilesCache = {};
      }
      if (!this.tileset) {
        this.tileImgs = [];
        return;
      }
      this.tileImgs = this.tileset.tiles.map(() => '');
      const tileImgs = this.tileImgs;
      this.tileset.tiles.forEach(async (tile, index) => {
        const canvas = await this.getTileCanvas(index);
        tileImgs[index] = canvas.toDataURL("image/png");
      });
    },
    selectTile(tileIndex) {
      this.$emit('change', { tileIndex });
    },
    getTileCanvas(tileIndex) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          try {
            if (!this.tileset) return;
        		const tile = this.tileset.tiles[tileIndex];
            if (!tile) return;
        		this.tilemapViewer.getTile(this.tilesetId, tileIndex, function (data) {
        			let canvas;
        			if (tile.extend) {
        				canvas = data.images['00000000'];
        			} else {
        				canvas = data.image;
        			}
        			resolve(canvas);
        		});
          } catch (e) {
            reject(e);
          }
        }, 0);
      });
    }
  },
  watch: {
    'tilesetId': function () {
      this.renderTiles();
    },
    'tileset': {
      handler() {
        this.renderTiles();
      },
      deep: true
    }
  },
  mounted: function () {
    const assets = GameStudio.getFilesWithExtensions(['.png', '.jpg']).toNameData();
    this.tilemapViewer = new TilemapViewer({tilesets: this.tilesets, assets: assets, assetsCache: this.assetsCache});
    this.renderTiles();
  }
}
</script>

<style lang="css" scoped>
</style>
